<template>
    <div>
        <a-row>
            <a-col span="5"><a style="float:right;margin-right: 30px">名称:</a></a-col>
            <a-col span="6">
                <a>{{dataList.name}}</a>
            </a-col>
            <a-col span="5"><a style="float:right;margin-right: 30px">版本号:</a></a-col>
            <a-col span="6">
                <a>{{dataList.no}}</a>
            </a-col>
        </a-row>
        <a-row>
            <a-col span="5"><a style="float:right;margin-right: 30px">URL:</a></a-col>
            <a-col span="9">
                <a>{{dataList.url}}</a>
            </a-col>
            <a-col span="3">
                <a-button type="primary" @click="changeDown(dataList)">
                    点击下载
                </a-button>
            </a-col>
            <a-col span="3">
                <a-button type="primary" @click="insert">
                    新增版本
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns"
                 :scroll="{y:550}"
                 :data-source="dataList.appVersions"
                 :pagination="false"
                 rowKey="id">
            <template slot="createDt" slot-scope="text,row">
                <a style="color: #666666">{{getTime(row.createDt)}}</a>
            </template>
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;color:orangered" @click="changeVer(row)">变更为当前更新版本</a>
                <a style="padding-left:5px;color:cornflowerblue" @click="changeDown(row)">下载</a>
            </template>
        </a-table>
        <a-modal width="200px"
                 :centered="true"
                 :visible="visible"
                 :bodyStyle="{height:'200px',padding:'0px'}"
                 :footer="null"
                 :closable="false"
                 @cancel="close">
            <div @click="close" style="text-align: center;">
                <vue-qr :text="url" style="width: 200px;height: 200px" :size="200"/>
            </div>
        </a-modal>
        <a-modal :visible="insertVisible"
                 width="600px"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="{}"
                 title="版本控制"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="cancel">
            <a-row style="margin-bottom: 10px">
                <a-col span="2"/>
                <a-col span="22">序 号：<a-input-number v-model="insertData.orderNo" style="width: 300px"/></a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col span="2"/>
                <a-col span="22">名 称：<a-input v-model="insertData.name" style="width: 300px"/></a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col span="2"/>
                <a-col span="20" style="left: -10px">版本号：<a-input-number v-model="insertData.no" style="width: 300px"/></a-col>
            </a-row>
            <a-row style="margin-bottom: 30px">
                <a-col span="2"/>
                <a-col span="22">备 注：<a-input v-model="insertData.remark" style="width: 300px"/></a-col>
            </a-row>
            <a-row style="margin-bottom: 10px">
                <a-col span="4"/>
                <a-col span="12">
                    <AppUpload :tempUrl.sync="insertData.url"/>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
    import {appQueryList,appEditDetail} from './js/ApiSystem'
    import AppUpload from '../../ui/AppUpload'
    import VueQr from 'vue-qr';
    import notification from "ant-design-vue/lib/notification";

    // import {baseURL} from '../../config/Request'
    const columns = [
        {
            title: '版本名称',
            dataIndex: 'name',
            key: 'name',
            width: '15%',
            ellipsis: true,
            align:'center',
        },
        {
            title: '创建时间',
            dataIndex: 'createDt',
            key: 'createDt',
            width: '15%',
            ellipsis: true,
            align:'center',
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '版本号',
            dataIndex: 'no',
            key: 'no',
            width: '15%',
            ellipsis: true,
            align:'center',
        },
        {
            title: '地址',
            dataIndex: 'url',
            key: 'url',
            width: '25%',
            ellipsis: true,
            align: 'center',
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: '15%',
            ellipsis: true,
            align: 'center',
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '15%',
            align:'center',
            scopedSlots: {customRender: 'operation'},
        },
    ];
    export default {
        name: "VersionControl",
        components: {
            AppUpload,VueQr
        },
        data(){
            return{
                columns,
                dataList:{},
                visible: false,
                insertVisible: false,
                url:'',
                insertData: {},
            }
        },
        methods:{
            changeVer(row){
                if(row.id === this.dataList.id){
                    notification.error({
                        message: '此版本已是当前更新版本',
                    });
                }else{
                    this.dataList.isNow = "1";
                    appEditDetail(this.dataList).then(()=>{
                        row.isNow = "0";
                        appEditDetail(row).then(()=>{
                            this.refresh()
                        })
                    })
                }
            },
            changeDown(row){
                this.url = row.url;
                this.visible = true;
            },
            refresh(){
                appQueryList({}).then(res=>{
                    this.dataList= res.data.data;
                })
            },
            close(){
                this.visible = false
            },
            insert(){
                this.insertData = {};
                this.insertVisible = true
            },
            add(){
                this.insertData.orderNo = this.insertData.orderNo + '';
                this.insertData.isNow = '0';
                appEditDetail(this.insertData).then(()=>{
                    this.insertVisible = false;
                    this.refresh()
                })
            },
            cancel(){
                this.insertVisible = false
            },
            // 页面改时间显示
            getTime(date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
            },
        },
        created() {
            this.refresh()
        }
    }

</script>

<style scoped>
    a{
        color: black;
    }
    img {
        width: 132px;
        height: 132px;
        background-color: #fff;
        padding: 6px;
        box-sizing: border-box;
    }
</style>
